var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.648 3.82422L22.1888 5.2561C22.579 5.34152 22.857 5.68704 22.857 6.08644V20.681C22.857 21.2522 22.305 21.6608 21.7588 21.494L15.648 19.6281L9.20229 21.5963L2.83362 19.8857C2.46225 19.786 2.2041 19.4493 2.2041 19.0648V4.7172C2.2041 4.1719 2.7103 3.76764 3.24209 3.88825L9.19192 5.23757L15.648 3.82422ZM8.43904 6.60492L3.7041 5.53111V18.5663L8.43904 19.8381V6.60492ZM9.93904 19.8029L14.898 18.2887V5.52393L9.93904 6.60954V19.8029ZM16.398 5.52393V18.2887L21.357 19.8029V6.60954L16.398 5.52393Z",
    fill: "#164A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapInactive);
export default __webpack_public_path__ + "static/media/map-inactive.a85f38461a7abd5c81fc716987cfa2bd.svg";
export { ForwardRef as ReactComponent };